import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/styles/site.css";
import "@/styles/enhancements.css";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import ComingSoon from "@/pages/ComingSoon";
import Review from "@/pages/Review";
import Reader from "@/pages/Reader";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { AskScottie } from "@/components/site/AskScottie";
import { ExitIntent } from "@/components/site/ExitIntent";
import { ResumeBanner } from "@/components/site/ResumeBanner";
import { PreviewBadge } from "@/components/site/PreviewBadge";
import { SiteContentProvider, useSite } from "@/context/SiteContent";

function ChatGate() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/read")) return null;
  return (
    <>
      <AskScottie />
      {pathname === "/" && <ExitIntent />}
      {pathname === "/" && <ResumeBanner />}
    </>
  );
}

function SiteGate() {
  const { pathname } = useLocation();
  const { siteMode, previewActive, loaded } = useSite();
  const bypass = pathname.startsWith("/admin") || pathname.startsWith("/payment") || pathname.startsWith("/review") || pathname.startsWith("/read");
  if (!loaded && !bypass) return <div className="site-splash" data-testid="site-splash" />;
  if (siteMode === "maintenance" && !previewActive && !bypass) return <ComingSoon />;
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/review/:token" element={<Review />} />
        <Route path="/read" element={<Reader />} />
        <Route path="/privacy" element={<Legal kind="privacy" />} />
        <Route path="/terms" element={<Legal kind="terms" />} />
        <Route path="/disclaimer" element={<Legal kind="disclaimer" />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <ChatGate />
      {siteMode === "maintenance" && previewActive && !bypass && <PreviewBadge />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteContentProvider>
          <SiteGate />
        </SiteContentProvider>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
